// Composables
import { useColor } from '@/composables/color'

// Utilities
import { computed, unref } from 'vue'
import { getCurrentInstanceName, propsFactory } from '@/util'

// Types
import type { PropType } from 'vue'
import type { MaybeRef } from '@/util'

export const allowedVariants = [
  'outlined',
  'plain',
  'text',
  'contained',
  'contained-flat',
  'contained-text',
] as const

export type Variant = typeof allowedVariants[number]

export interface VariantProps {
  color?: string
  variant: Variant
}

export function genOverlays (isClickable: boolean, name: string) {
  return (
    <>
      { isClickable && <div class={`${name}__overlay`} /> }

      <div class={`${name}__underlay`} />
    </>
  )
}

export const makeVariantProps = propsFactory({
  color: String,
  variant: {
    type: String as PropType<Variant>,
    default: 'contained',
    validator: (v: any) => allowedVariants.includes(v),
  },
}, 'variant')

export function useVariant (
  props: MaybeRef<VariantProps>,
  name = getCurrentInstanceName(),
) {
  const variantClasses = computed(() => {
    const { variant } = unref(props)
    return `${name}--variant-${variant}`
  })

  const { colorClasses, colorStyles } = useColor(computed(() => {
    const { variant, color } = unref(props)
    return {
      [['contained', 'contained-flat'].includes(variant) ? 'background' : 'text']: color,
    }
  }))

  return { colorClasses, colorStyles, variantClasses }
}
